<template>
  <div>
    <el-form
      ref="formRef"
      :label-position="labelPosition"
      label-width="140px"
      :model="form"
      :rules="rules"
    >
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="form.phone" />
      </el-form-item>
      <el-form-item label="名称">
        <el-input v-model="form.name" />
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="form.email" />
      </el-form-item>
      <el-form-item label="邮箱密码" prop="tk_password">
        <el-input v-model="form.tk_password" />
      </el-form-item>
      <el-form-item label="账号" prop="account">
        <el-input v-model="form.account" />
      </el-form-item>
      <el-form-item label="账号密码" prop="password">
        <el-input v-model="form.password" />
      </el-form-item>
      <el-form-item label="ip地址">
        <el-input v-model="form.ip_address" />
      </el-form-item>
      <el-form-item label="银行卡号" prop="card_num">
        <el-input v-model="form.card_num" />
      </el-form-item>
      <el-form-item label="有效期至（月份）" prop="valid_thru_month">
        <el-input v-model="form.valid_thru_month" />
      </el-form-item>
      <el-form-item label="有效期至（日）" prop="valid_thru_day">
        <el-input v-model="form.valid_thru_day" />
      </el-form-item>
      <el-form-item label="CVV验证码" prop="cvv">
        <el-input v-model="form.cvv" />
      </el-form-item>
      <el-form-item label="充值金额" prop="amount">
        <el-input v-model="form.amount" />
      </el-form-item>
      <el-form-item label="银行卡片归属" prop="attribution">
        <el-input v-model="form.attribution" />
      </el-form-item>
      <el-form-item label="验证码接收地址" prop="e_address">
        <el-input v-model="form.e_address" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { payoneercardcreate, payoneercardupdate } from '@/api/taobaoLink.js'
export default {
  data() {
    return {
      labelPosition: 'right',
      form: {
        phone: '',
        email: '',
        tk_password: '',
        account: '',
        password: '',
        ip_address: '',
        card_num: '',
        valid_thru_month: '',
        valid_thru_day: '',
        cvv: '',
        name: '',
        amount: '',
        attribution: '',
        e_address: '',
        id: null
      },
      rules: {
        phone: [{ required: true, message: '手机号不能为空', trigger: 'blur' }],
        email: [{ required: true, message: '邮箱不能为空', trigger: 'blur' }],
        tk_password: [
          { required: true, message: '邮箱密码不能为空', trigger: 'blur' }
        ],
        account: [{ required: true, message: '账号不能为空', trigger: 'blur' }],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ],
        card_num: [
          { required: true, message: '卡号不能为空', trigger: 'blur' }
        ],
        valid_thru_month: [
          { required: true, message: '有效期月份不能为空', trigger: 'blur' }
        ],
        valid_thru_day: [
          { required: true, message: '有效期日期不能为空', trigger: 'blur' }
        ],
        cvv: [{ required: true, message: '验证码不能为空', trigger: 'blur' }],
        amount: [{ required: true, message: '金额不能为空', trigger: 'blur' }],
        attribution: [
          { required: true, message: '卡片归属不能为空', trigger: 'blur' }
        ],
        e_address: [
          { required: true, message: '接码地址不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    send(type, item) {
      this.type = type
      if (this.type === 2) {
        Object.assign(this.form, item)
      }
    },
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          const apiMethod =
            this.type === 1 ? payoneercardcreate : payoneercardupdate
          apiMethod(this.form).then((res) => {
            this.$emit('updata')
            this.$message.success(this.type === 1 ? '创建成功' : '修改成功')
          })
        } else {
          this.$message.error('请填写完整信息')
        }
      })
    }
  }
}
</script>

<style scoped></style>
